
declare var require: any;
import React, { Component } from "react";
// reactstrap components
import {
  Container,
  Row,
  Col,
  Badge
} from "reactstrap";
import { Link } from 'react-router-dom';
import DeckCard from '../DeckCard/DeckCard';
import connect from 'redux-connect-decorator';
import { getTeachers } from '../../actions/teacherActions';

@connect(
  state => ({
    teachers: state.teacher.teachers,
    loading: state.teacher.loading
  }),
  {
    getTeachers
  }
)
class TeacherCCL extends Component<any, any> {

  componentDidMount() {
    this.props.getTeachers();
  }

  render() {
    const { teachers } = this.props;

    return (
      <>
        <section className="py-4">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  { teachers && teachers.length > 0 && <DeckCard data={ teachers } /> }
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5 bg-school" style={{ height: '430px'}}>
                    <h1>ĐỘI NGŨ GIẢNG VIÊN </h1>
                    <ul className="list-unstyled mt-5">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="ni ni-settings-gear-65" />
                            </Badge>
                          </div>
                          <div>
                            <h4 className="mb-0">
                            Am hiểu cặn kẽ về cách chấm điểm bộ máy CCL Magic
                            </h4>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="ni ni-html5" />
                            </Badge>
                          </div>
                          <div>
                            <h4 className="mb-0">Ân cần, tận tâm trong phương pháp giảng dạy</h4>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="ni ni-satisfied" />
                            </Badge>
                          </div>
                          <div>
                            <h4 className="mb-0">
                            Trainer giúp học viên tập trung điểm mạnh để đạt Target nhanh nhất, hiệu quả nhất
                            </h4>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
      </>
    )
  }
}

export default TeacherCCL;
